import httpClient from './httpClient';

export const fetchPayments = async (studentId) => {
  const { data } = await httpClient.get(`/payments/${studentId}`);
  return data;
};

export const createPayment = async (payload) => {
  const { data } = await httpClient.post('/payments', payload);
  return data;
};

export const updatePayment = async (id, payload) => {
  const { data } = await httpClient.put(`/payments/${id}`, payload);
  return data;
};

export const deletePayment = async (id) => {
  await httpClient.delete(`/payments/${id}`);
};

